import axios from "axios";
import { IUserDetail } from "../models/IUserDetail";
import { configWithUserToken } from "../services/config";
import { getUserToken } from "./tokenUtils";

/** API'den gelen hata dizisinden açıklama metnini çeker.
 *  Format: [{ code: "17", description: "..." }]
 *  Bulunamazsa fallback döner. */
export const getApiErrorMessage = (err: unknown, fallback: string): string => {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data;
    if (Array.isArray(data) && data.length > 0 && data[0].description) {
      return data[0].description;
    }
  }
  return fallback;
};

export { decrypt, getWebToken, getUserToken } from "./tokenUtils";

export const getUserDetails = (): Promise<IUserDetail | null> => {
  const tokenObj = getUserToken();
  if (tokenObj) {
    return configWithUserToken
      .get<IUserDetail>("Auth/CustomerDetails/" + tokenObj.userId)
      .then((res) => res.data ?? null)
      .catch(() => null);
  }
  return Promise.resolve(null);
};